<div class="container">
  <h1>Gestion des couleurs</h1>
  <form (ngSubmit)="saveColor()">
    <div class="input-container">
      <label for="title">Titre :</label>
      <input type="text"
             id="title"
             class="form-control"
             [(ngModel)]="newColor.title"
             name="title"
             required />
    </div>

    <div class="input-container">
      <label for="colorCode">Code couleur :</label>
      <input type="text"
             id="colorCode"
             class="form-control"
             [(ngModel)]="newColor.colorCode"
             name="colorCode" />
    </div>

    <div class="input-container">
      <label for="mission">Mission :</label>
      <input type="text"
             id="mission"
             class="form-control"
             [(ngModel)]="newColor.mission"
             name="mission" />
    </div>

    <button type="submit" class="btn btn-primary">
      {{ selectedColor?.id ? 'Mettre à jour la couleur' : 'Ajouter une couleur' }}
    </button>
  </form>


  <!-- Message d'erreur si besoin -->
  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>

  <!-- Liste des couleurs existantes -->
  <div *ngIf="colors$ | async as colorsList" class="color-list">
    <h2>Couleurs existantes</h2>
    <ul>
      <li *ngFor="let color of colorsList">
        <strong>{{ color.title }}</strong> -

        <!-- Affichage conditionnel -->
        <span *ngIf="color.colorCode && !color.mission">{{ color.colorCode }}</span>
        <span *ngIf="color.mission && !color.colorCode">{{ color.mission }}</span>

        <!-- Gestion des deux étant remplis (ne devrait pas arriver mais à gérer si jamais) -->
        <span *ngIf="color.colorCode && color.mission">
          <i>Erreur: les deux champs sont remplis</i>
        </span>

        <button class="btn btn-secondary" (click)="editColor(color)">Modifier</button>
        <button class="btn btn-danger" (click)="deleteColor(color.id)">Supprimer</button>
      </li>
    </ul>
  </div>

  <!-- Message si aucune couleur n'est disponible -->
  <div *ngIf="(colors$ | async)?.length === 0" class="alert alert-info">
    Aucune couleur disponible.
  </div>
</div>
